import axios from 'axios';
import { toast } from 'react-toastify';
import ApiConfig from '../config/ApiConfig';
import { deleteApiPayload, errorMessage } from '../lib/helper';
import { STATUS_200, STATUS_300 } from '../data/constants';
import {
  setSoldImagesListing,
  setSoldImagesListingError,
  setSoldImagesListingLoading,
  setImageSearchData,
  setImageSearchError,
  setConfirmedOrderListing,
  setConfirmedOrderListingError,
  setConfirmedOrderListingLoading,
} from '../redux/legal';

export const soldImageListings = (payload) => {
  if (payload !== undefined) {
    return async (dispatch) => {
      try {
        dispatch(setSoldImagesListingLoading(true));
        const resp = await axios.post(`${ApiConfig.listOfSoldImages}`, payload);
        if (
          resp?.data?.status >= STATUS_200 &&
          resp?.data?.status < STATUS_300
        ) {
          dispatch(setSoldImagesListing(resp.data.data));
          dispatch(setSoldImagesListingLoading(false));
        } else {
          throw resp;
        }
      } catch (e) {
        dispatch(
          setSoldImagesListingError({
            isError: true,
            message: errorMessage(e),
          }),
        );
        toast.error(errorMessage(e), {
          autoClose: 2500,
        });
        dispatch(setSoldImagesListingLoading(false));
      }
    };
  }
};

export const SoldImagesReport = async (payload) => {
  if (payload !== undefined) {
    try {
      const resp = await axios.post(`${ApiConfig.listOfSoldImages}`, payload, { responseType: 'blob' });
      if (resp?.status >= STATUS_200 && resp?.status < STATUS_300) {
        return { status: true, data: resp?.data }
      } else {
        throw resp;
      }
    } catch (e) {
      toast.error(errorMessage(e), {
        autoClose: 2500,
      });
      return { status: false, data: null }
    }
  }
};
export const searchImageByName = async (keywords) => {
  if (keywords !== undefined) {
    try {
      const response = await axios.post(
        `${ApiConfig.imagesearchByName}?keywords=${keywords?.trim()}`
      );
      if (response?.status >= STATUS_200 && response?.status < STATUS_300) {
        return response;
      }
    } catch (e) {
      toast.error(errorMessage(e), {
        autoClose: 2000,
      });
      return e;
    }
  }
};
export const searchImageResult = async (keyword, size, showPerPage, sortBy) => {
  if (keyword !== undefined) {
    try {
      const response = await axios.post(
        `${ApiConfig.getImagesSearchList
        }?keyword=${keyword?.trim()}&size=${size}&page=${showPerPage}${sortBy ? `&sortBy=${sortBy}` : ""
        }`
      );
      if (response?.status >= STATUS_200 && response?.status < STATUS_300) {
        return response;
      }
    } catch (e) {
      toast.error(errorMessage(e), {
        autoClose: 2000,
      });
      return e;
    }
  }
};

export const AutoSuggestForExclusiveImage = async (keyword) => {
  if (keyword !== undefined) {
    try {
      const response = await axios.post(
        `${ApiConfig.autosuggest}?keyword=${keyword}`,
      );
      if (response?.status >= STATUS_200 && response?.status < STATUS_300) {
        return response.data?.data;
      }
    } catch (e) {
      toast.error(errorMessage(e), {
        autoClose: 2000,
      });
      return e;
    }
  }
};

export const ImageSearchAfterUpload = (formData) => {
  return async (dispatch) => {
    try {
      const resp = await axios.post(`${ApiConfig.uploadSearchImage}`, formData);
      if (resp?.status >= STATUS_200 && resp?.status < STATUS_300) {
        dispatch(setImageSearchData(resp?.data?.hits));
        return true;
      } else {
        throw new Error(`Error: ${resp?.status}`);
      }
    } catch (e) {
      if (e.response) {
        console.error("Error response data:", e.response.data);
      }
      dispatch(
        setImageSearchError({
          isError: true,
          message: errorMessage(e),
        })
      );
      toast.error(errorMessage(e), {
        autoClose: 2500,
      });
      return false;
    }
  };
};

export const ConfirmedOrderListings = (payload) => {
  if (payload !== undefined) {
    return async (dispatch) => {
      try {
        dispatch(setConfirmedOrderListingLoading(true));
        const resp = await axios.post(`${ApiConfig.confirmOrderListing}`, payload);
        if (
          resp?.data?.status >= STATUS_200 &&
          resp?.data?.status < STATUS_300
        ) {
          dispatch(setConfirmedOrderListing(resp.data.data));
          dispatch(setConfirmedOrderListingLoading(false));
        } else {
          throw resp;
        }
      } catch (e) {
        dispatch(
          setConfirmedOrderListingError({
            isError: true,
            message: errorMessage(e),
          }),
        );
        toast.error(errorMessage(e), {
          autoClose: 2500,
        });
        dispatch(setConfirmedOrderListingLoading(false));
      }
    };
  }
};